import store from "../index.js";
import api from "../../utils/api.js";

export const modules = {
  store,
};

export const state = {
  _item: {},
  _items: [],
  _searchResults: [],
};

export const mutations = {
  setUserInfo(state, item) {
    state._item = item;
  },
  setSearchResults(state, payload) {
    state._searchResults = payload;
  },
};

export const actions = {
  async acUserInfo({ commit }, query) {
    try {
      const result = await api.get(`/api/v1/user-info?email=${query}`);
      if (result?.data?.code === 0) {
        commit("setUserInfo", result.data.data);
      }
      return true;
    } catch (err) {
      return false;
    }
  },
  acUserInfoReload({ commit, state }, payload) {
    console.log("payload", payload);
    // 기존 탈퇴 정보 유지
    const updatedPayload = {
      ...payload,
      withdrawBlockReasons: payload.withdrawBlockReasons ?? state._item?.withdrawBlockReasons,
      withdrawSurvey: payload.withdrawSurvey ?? state._item?.withdrawSurvey,
    };
    commit("setUserInfo", updatedPayload);
  },
  async acForceWithdrawalRequest({ commit }, memberNo) {
    try {
      const result = await api.patch(`/api/v1/user/admin/force-withdrawal-request`, {
        member_no: memberNo,
      });
      if (result?.data?.code === 0) {
        return true;
      }
      return false;
    } catch (err) {
      console.error("acForceWithdrawalRequest error", err);
      return false;
    }
  },
  async acRevertWithdrawalRequest({ commit }, memberNo) {
    try {
      const result = await api.patch(`/api/v1/user/admin/revert-withdrawal-request`, {
        member_no: memberNo,
      });
      if (result?.data?.code === 0) {
        return true;
      }
      return false;
    } catch (err) {
      console.error("acRevertWithdrawalRequest error", err);
      return false;
    }
  },
  async acSearchUser({ commit }, { type, keyword }) {
    try {
      const { data } = await api.get(`/api/v1/user-info/search?type=${type}&keyword=${encodeURIComponent(keyword)}`);
      commit("setSearchResults", data.data || []);
      return data.data || [];
    } catch (e) {
      commit("setSearchResults", []);
      return [];
    }
  },
  async acUserInfoByUserNo({ commit }, userNo) {
    try {
      const { data } = await api.get(`/api/v1/user-info?userNo=${userNo}`);
      commit("setUserInfo", data.data);
      return data.data;
    } catch (e) {
      return null;
    }
  },
  // 리포트 CS 문의번호(report_code, NR-XXXXXXXX)로 단건 조회. 없으면 BE가 [] 반환 → null 정규화.
  async acReportByCode(_, code) {
    try {
      const { data } = await api.get(`/api/v1/report/admin/by-code?code=${encodeURIComponent(code)}`);
      const report = data?.data;
      return Array.isArray(report) ? null : report || null;
    } catch (e) {
      return null;
    }
  },
};

export const getters = {
  _searchResults(state) {
    return state._searchResults;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
